import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import HelpIcon from 'packages/kakapo-ui-kit/assets/icons/HelpIcon';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import PopoverTarget from 'packages/kakapo-ui-kit/components/popovers/PopoverTarget';

const Container = styled(Box)``;

const Title = styled(Box)`
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 14px;
`;

const Value = styled(Box)<{ small?: boolean }>`
	line-height: 40px;
	font-size: ${(props) => (props.small ? 18 : 34)}px;
	font-weight: bold;
`;

const Quantity = styled.span`
	font-size: 16px;
`;

const Byline = styled(Box)`
	color: ${(props) => props.theme.colors.lightBlueDark};
`;

export default function ScalarMetric(props: {
	title: string;
	explanation?: string;
	value?: string;
	quantity?: string;
	byline?: string;
	small?: boolean;
	loading: boolean;
}) {
	const { title, loading, small, value, quantity, byline } = props;

	return (
		<Container p={3}>
			<Flex flexDirection="row" alignItems="center">
				<Title flexGrow={1} flexShrink={1}>
					{title}
				</Title>
				{loading && <Spinner isLoading size="12px" verticalMargin={0} />}

				{props.explanation && (
					<Box ml={3} flexShrink={0} flexGrow={0}>
						<PopoverTarget
							content={
								<Box p={3}>
									<ParagraphSmall color="slateBlue">{props.explanation}</ParagraphSmall>
								</Box>
							}
						>
							<HelpIcon color="slateBlue" />
						</PopoverTarget>
					</Box>
				)}
			</Flex>
			<Value small={small}>
				{loading || !value ? '-' : value}
				<Quantity>{quantity}</Quantity>
			</Value>
			{byline && <Byline mt={1}>{byline}</Byline>}
		</Container>
	);
}
